<template>
    <v-container id="extended-tables" fluid tag="section">
        <base-v-component heading="" link="componetns/simple-tables" />

        <base-material-card color="success" icon="mdi-clipboard-text" inline title="Generar valores a cobrar 1"
            class="px-5 py-3 mb-5">
            <v-row>
                <v-col cols="12" md="6">
                    <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones"
                        item-text="name" item-value="id" persistent-hint return-object single-line
                        v-on:change="listarEdificios()"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name"
                        item-value="id" persistent-hint return-object single-line v-on:change="listar()"></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12" class="mt-10">
                    <v-data-table :headers="headers" :items="Properties" sort-by="calories" class="elevation-1"
                        :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar">
                        <template v-slot:item.dueDate="{ item }">
                            {{ formatDate(item.dueDate) }}
                        </template>
                     
                        <template v-slot:item.amount="{ item }">
                            {{ formatCurrency(item.amount) }}
                        </template>
                            <template v-slot:item.balanceDue="{ item }">
                            {{ formatCurrency(item.balanceDue) }}
                        </template>
                            <template v-slot:item.totalPaid="{ item }">
                            {{ formatCurrency(item.totalPaid) }}
                        </template>
                        <template v-slot:top>
                             <v-row>
                                <v-col cols="12" md="6">
                                <v-radio-group v-model="row" row mandatory @change="changeRow">
                                    <v-radio label="Pendiente" value="Pendiente"></v-radio>
                                    <v-radio label="Pagado" value="Pagado"></v-radio>
                                    <v-radio label="Todos" value="Todos"></v-radio>
                                </v-radio-group>
                                </v-col>

                            </v-row>
                            <v-toolbar flat>
                                <v-toolbar-title></v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                                    hide-details></v-text-field>

                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-menu offset-y v-bind="attrs" v-on="on">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                                                    Nuevo
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item v-for="(item, index) in items" :key="index"
                                                    @click="openDialog(item.dialog)">
                                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5 text-bold">{{ formTitle }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-text-field v-model="medicamento"
                                                            label="medicamento"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-text-field v-model="presentacion"
                                                            label="presentacion"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-text-field v-model="literatura"
                                                            label="literatura"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                                            <v-btn color="primary" @click="guardar()"> GUardar </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Esta seguro de eliminar datos de
                                            alicuotas?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="openDetalle(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="enviarEmail(item)">
                                        <v-icon dense color="secondary">mdi-mail</v-icon>
                                    </v-btn>
                                </template>
                                <span>Enviar email con documentos</span>
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="deleteItem(item)">
                                        <v-icon dense color="primary">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eliminar mascota</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize"> Recargar </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </base-material-card>

        <v-snackbar v-model="snackbar" :timeout="timeout">
            {{ text }}

            <template v-slot:action="{ attrs }">
                <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <!-- 🔹 Popup 1: Selección de mes -->
        <v-dialog v-model="dialog1" max-width="400">
            <v-card>



                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="dialog1 = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Generador de alicuotas</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-date-picker v-model="picker" type="month"></v-date-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" text @click="GenerarPorFecha()">Guardar</v-btn>
                    <v-btn color="grey" text @click="dialog1 = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 🔹 Popup 2: Selección de mes, monto y descripción -->
        <v-dialog v-model="dialog2" max-width="400">
            <v-card>
                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="dialog2 = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Cuota extraordinaria</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-date-picker v-model="picker" type="month"></v-date-picker>
                    <v-text-field v-model="amount" label="Monto" prefix="$" type="number"></v-text-field>
                    <v-textarea v-model="description" label="Descripción" rows="2"></v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" text @click="GenerarPorFechaValor()">Guardar</v-btn>
                    <v-btn color="grey" text @click="dialog2 = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 🔹 Popup 3: Iot -->
        <v-dialog v-model="dialog3" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>

                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog3 = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Seleccionar el periodo de los sensores</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>

                <v-card-text class="text-center">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-data-table :headers="headersSensores" :items="Sensores" sort-by="calories"
                                class="elevation-1" :search="search" :loading="loadingTableSensors"
                                loading-text="Cargando... Por favor esperar">
                                <template v-slot:item.estado="{ item }">
                                    <v-simple-checkbox v-model="item.estado" disabled></v-simple-checkbox>
                                </template>
                                <template v-slot:item.invoice="{ item }">
                                    <v-simple-checkbox v-model="item.invoice" disabled></v-simple-checkbox>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" large @click="listarDetallesSensor(item)">
                                                <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ver detalles</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" large @click="GenerarPorSensor(item)">
                                                <v-icon dense color="secondary">mdi-content-save</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Generar valores a pagar</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <!--
                <v-card-actions>
                    <v-btn color="primary" text @click="GenerarPorFecha()">Guardar</v-btn>
                    <v-btn color="grey" text @click="dialog1 = false">Cancelar</v-btn>
                </v-card-actions>
                -->
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSensorDetails" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Detalle de mediciones del sensor</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-row>
                        <v-col cols="12" sm="12" lg="12">
                            <v-data-table :headers="headersDetailsSensors" :items="DetailsSensors" sort-by="calories"
                                class="elevation-1" :search="search" :loading="loadingTableDetails"
                                loading-text="Cargando... Por favor esperar">
                                <!-- 🔹 Fila de totales -->
                                <template v-slot:body.append>
                                    <tr>
                                        <td colspan="1"><strong>Total:</strong></td>
                                        <td class="text-left"><strong>{{ sumValor }}</strong></td>
                                        <td class="text-left"><strong>{{ sumPagos }}</strong></td>
                                        <td class="text-left"><strong>{{ sumSaldo }}</strong></td>
                                        <td></td> <!-- Espacio para acciones -->
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="grey" text @click="dialogSensorDetails = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPagos" max-width="400">
            <v-card>

                <v-card-title>
                    <span class="text-h5">Ingresar pagos</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-date-picker v-model="pickerPayment"></v-date-picker>
                    <v-text-field v-model="amountPayment" label="Monto" prefix="$" type="number"></v-text-field>
                    <v-textarea v-model="methodPayment" label="Metodo" rows="2"></v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" text @click="GenerarPago()">Guardar</v-btn>
                    <v-btn color="grey" text @click="dialog2 = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDetails" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Detalles de propiedades</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-card-text>
                    <v-alert border="top" color="indigo" dark>
                        Descripcion : {{ descriptionPopUp }} Fecha de pago: {{ formatDate(fechaPagoPopUp) }}
                    </v-alert>
                    <v-data-table :headers="headersDetails" :items="Details" sort-by="calories" class="elevation-1"
                        :search="search" :loading="loadingTableDetails" loading-text="Cargando... Por favor esperar">
                        <template v-slot:item.amount="{ item }">
                            {{ formatCurrency(item.amount) }}
                        </template>

                        <template v-slot:item.total_paid="{ item }">
                            {{ formatCurrency(item.total_paid) }}
                        </template>
                        <template v-slot:item.balance_due="{ item }">
                            <v-chip :color="getColor(item.balance_due)">
                                {{ formatCurrency(item.balance_due) }}
                            </v-chip>

                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!--
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="popUpPagos(item)">
                                        <v-icon dense color="primary">mdi-cash</v-icon>
                                    </v-btn>
                                </template>
                <span>Ingresar pago</span>
                </v-tooltip>
                -->
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="verPaymentsDetalles(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>

                        </template>
                        <!-- 🔹 Fila de totales -->
                        <template v-slot:body.append>
                            <tr>
                                <td colspan="5"><strong>Total:</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumValor) }}</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumPagos) }}</strong></td>
                                <td class="text-left"><strong>{{ formatCurrency(sumSaldo) }}</strong></td>
                                <td></td> <!-- Espacio para acciones -->
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPagosDetails" max-width="800">
            <v-card>
                <v-toolbar dark color="secondary">
                    <v-btn icon dark @click="dialogPagosDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Detalles de pagos</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                    <v-data-table :headers="headersPaymentDetails" :items="PaymentDetails" sort-by="calories"
                        class="elevation-1" :search="search" :loading="loadingTableDetails"
                        loading-text="Cargando... Por favor esperar">
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" large @click="popUpPagos(item)">
                                        <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver detalles</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>

                    <v-btn color="grey" text @click="dialogPagosDetails = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";
export default {
    name: "DashboardExtendedTables",

    data: () => ({
        headersDetailsSensors: [
            { text: "sensor", value: "sensor" },
            { text: "Medicion", value: "measure" },
            { text: "Valor planilla", value: "invoice_measure" },
            { text: "Valor $", value: "invoice_amount" },
            { text: "Unidad", value: "unit_of_measurement" },
            //{ text: "Fecha inicio", value: "start_date" },
            //{ text: "Fecha fin", value: "end_date" },
            //{ text: "Estado", value: "estado" },
            //{ text: "Acciones", value: "actions", sortable: false },
        ],
        DetailsSensors: [],
        dialogSensorDetails: false,
        headersSensores: [
            { text: "Periodo", value: "periods" },
            { text: "Medicion sensores m3", value: "measure" },
            { text: "Valores planilla m3", value: "real_measure" },
            { text: "Valor planilla $", value: "amount" },
            //{ text: "Proceso Cerrado", value: "estado" },
            { text: "Factura", value: "invoice" },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        Sensores: [],
        loadingTableSensors: false,
        dialog: false,
        dialogDelete: false,
        headers: [
            //{ text: "Fecha de inicio", value: "start_date" },
            //{ text: "Fecha de fin", value: "end_date" },
            { text: "Fecha de pago", value: "dueDate" },
            { text: "Descripcion", value: "description" },
            { text: "Valor", value: "amount" },
            { text: "Pagos", value: "totalPaid" },
            { text: "Saldo", value: "balanceDue" },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        Properties: [],
        editedIndex: -1,
        medicamento: "",
        presentacion: "",
        literatura: "",
        search: "",
        loadingTable: false,
        snackbar: false,
        text: "",
        timeout: 6000,
        urbanizaciones: [],
        urbanizacion: [],
        edificios: [],
        edificio: [],
        items: [
            { title: "Alicuota", dialog: "dialog1" },
            { title: "Cuota extraordinaria", dialog: "dialog2" },
            { title: "IoT", dialog: "dialog3" }
        ],
        dialog1: false,
        dialog2: false,
        dialog3: false,
        picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        id_pago: "",
        pickerPayment: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        amountPayment: 0,
        methodPayment: "",
        description: '',
        amount: 0,
        Details: [],
        loadingTableDetails: false,
        headersDetails: [
            //{ text: "dateRange", value: "dateRange" },
            { text: "Documento", value: "identity_column" },
            // { text: "Fecha de pago", value: "dueDate" },
            //{ text: "Descripción", value: "description" },
            { text: "Propietario", value: "owner" },
            { text: "Tipo", value: "propertytype" },
            { text: "Número", value: "unitnumber" },
            { text: "Piso", value: "floor" },
            { text: "Valor $", value: "amount" },
            { text: "Pagos $", value: "total_paid" },
            { text: "Saldo $", value: "balance_due" },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        dialogDetails: false,
        dialogPagos: false,
        group_uq: '',
        dialogPagosDetails: false,
        headersPaymentDetails: [
            { text: "Metodo", value: "paymentMethod" },
            { text: "Fecha", value: "paymentDate" },
            { text: "Valor $", value: "amount" },
            { text: "No Documento", value: "documentNo" },
            { text: "Banco", value: "bank" },
        ],
        PaymentDetails: [],
        descriptionPopUp: "",
        fechaPagoPopUp: "",
         row: null,
    estado: "",
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nueva propiedad" : "Editar propiedad";
        },
        sumPagos() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.total_paid || 0), 0));
        },
        sumSaldo() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.balance_due || 0), 0));
        },
        sumValor() {
            return this.formatNumber(this.Details.reduce((sum, item) => sum + (item.amount || 0), 0));
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        loader() {
            const l = this.loader;
            this[l] = !this[l];

            setTimeout(() => (this[l] = false), 6000);

            this.loader = null;
        },
        dialog3(newValue) {
            if (newValue) {
                this.listarSensores();
            }
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        getColor(balance_due) {
            if (balance_due > 0) return 'red lighten-3'
            else if (balance_due == 0) return 'light-green lighten-2'
            else return 'orange lighten-1'
        },
         changeRow(value) {
      let me = this;
      console.log("Valor seleccionado:", value);
      me.estado = value;
      me.listar();
    },
        formatDate(date) {
            if (!date) return ""; // Evita errores si la fecha es nula o indefinida
            // Maneja valores nulos o indefinidos
            const d = new Date(date);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        },
        formatNumber(value) {
            return parseFloat(value).toFixed(2);
        },
        // Formatea como moneda con "$" y 2 decimales
        formatCurrency(value) {
            if (value == null) return "$0.00";
            return `$${parseFloat(value).toFixed(2)}`;
        },
        initialize() {
            this.listarUrbanizaciones();
        },
        listarSensores() {
            let me = this;
            //me.loadingTable = true;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTableSensors = true;
            axios
                .get(
                    "api/Consolidators/ConsolidatorPeriods/3B8FEAFC-0968-4E35-A1B6/" + me.edificio.id + "/false",
                    configuracion
                )
                .then(function (response) {
                    me.Sensores = response.data;
                    me.loadingTableSensors = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        listarUrbanizaciones() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get("api/Communities", configuracion)
                .then(function (response) {
                    me.urbanizaciones = response.data;
                    console.log(response.data);
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        listarEdificios() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.edificios = [];
            axios
                .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
                .then(function (response) {
                    me.edificios = response.data;
                    console.log(response.data);
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },

        listar() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTable = true;
            me.Properties = [];
            axios
                .get("api/AccountsReceivables/AccountsPeriods/" + me.edificio.id + "/" + me.estado, configuracion)
                .then(function (response) {
                    me.Properties = response.data;
                    //change to string bool value
                    me.loadingTable = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        openDetalle(item) {
            let me = this;

            me.dialogDetails = true;
            me.group_uq = item.group_uq;
            me.descriptionPopUp = item.description;
            me.fechaPagoPopUp = item.dueDate;
            me.verDetalles();

        },
        enviarEmail(item) {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };

            me.group_uq = item.group_uq;



            axios
                .get("api/EmailMailRelay/SendEmail/" + me.group_uq, configuracion)
                .then(function (response) {
                    console.log(response.data);

                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );

        },
        verDetalles() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.loadingTableDetails = true;

            axios
                .get("api/AccountsReceivables/AccountsPeriodsDetails/" + me.group_uq, configuracion)
                .then(function (response) {
                    me.Details = response.data;
                    //change to string bool value
                    me.loadingTableDetails = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        verPaymentsDetalles(item) {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            me.dialogPagosDetails = true;

            axios
                .get("api/Payments/PaymentDetails/" + item.id, configuracion)
                .then(function (response) {
                    me.PaymentDetails = response.data;
                    //change to string bool value
                    me.loadingTableDetails = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                }
                );
        },
        guardar() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            if (this.editedIndex > -1) {
                //edit
                console.log("Actualizar " + me.unico);
                axios
                    .put(
                        "api/mascotas/Actualizar",
                        {
                            unico: me.unico,
                            nombre: me.nombre,
                            tipo: me.tipo.tipo,
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.listar();
                        console.log(response);
                    })
                    .catch((err) => {
                        if (err.response.status == 401) {
                            this.$store.dispatch("salir");
                        }
                    });
            } else {
                console.log("crear medicamento");
                axios
                    .post(
                        "api/medicamentos/Crear",
                        {
                            medicamento_descripcion: me.medicamento,
                            presentacion: me.presentacion,
                            literatura: me.literatura,
                        },
                        configuracion
                    )
                    .then(function (response) {
                        me.listar();
                        console.log(response);
                    })
                    .catch((err) => {
                        if (err.response.status == 401) {
                            this.$store.dispatch("salir");
                        }
                    });
            }
            this.close();
        },
        popUpPagos(item) {
            let me = this;
            me.dialogPagos = true;
            console.log(item);
            me.id_pago = item.id;
        },
        editItem(item) {
            //this.editedIndex = this.desserts.indexOf(item);
            //this.editedItem = Object.assign({}, item);
            console.log(item);
            this.dialog = true;
        },

        deleteItem(item) {
            //this.editedIndex = this.desserts.indexOf(item);
            //this.editedItem = Object.assign({}, item);
            console.log(item);
            this.dialogDelete = true;
        },

        deleteItemConfirm() {
            this.desserts.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        listarDetallesSensor(item) {
            let me = this;
            me.dialogSensorDetails = true;
            // me.loadingTableDetails = true;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            axios
                .get(
                    "api/Consolidators/DetailsByGroup" + "/" + item.id,

                    configuracion
                )
                .then(function (response) {
                    me.DetailsSensors = response.data;
                    //me.loadingTableDetails = false;
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        GenerarPorFecha() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            console.log(me.picker);
            let yyyyMm = me.picker;
            let [year, month] = yyyyMm.split("-").map(Number);

            // Primer día del mes
            let firstDay = new Date(year, month - 1, 1);

            // Último día del mes
            let lastDay = new Date(year, month, 0);

            let startDate = firstDay.toISOString().split("T")[0]; // YYYY-MM-DD
            let endDate = lastDay.toISOString().split("T")[0];


            axios
                .post(
                    "api/AccountsReceivables/InsertAccountReceivableDate",
                    {
                        building_uq: me.edificio.id,
                        start_date: startDate,
                        end_date: endDate,
                    },
                    configuracion
                )
                .then(function (response) {
                    //me.listarPeriodos();
                    console.log(response.data[0]["error"]);
                    if (response.data[0]["error"]) {
                        me.snackbar = true;
                        me.text = response.data[0]["messagge"];
                    } else {
                        //me.listarPeriodos();
                        me.listar();
                        me.dialog1 = false;

                    }
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });

        },
        GenerarPorFechaValor() {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            let yyyyMm = me.picker;
            let [year, month] = yyyyMm.split("-").map(Number);

            // Primer día del mes
            let firstDay = new Date(year, month - 1, 1);

            // Último día del mes
            let lastDay = new Date(year, month, 0);

            let startDate = firstDay.toISOString().split("T")[0]; // YYYY-MM-DD
            let endDate = lastDay.toISOString().split("T")[0];

            axios
                .post(
                    "api/AccountsReceivables/InsertAccountReceivableDateFee",
                    {
                        building_uq: me.edificio.id,
                        start_date: startDate,
                        end_date: endDate,
                        Description: me.description,
                        Amount: me.amount
                    },
                    configuracion
                )
                .then(function (response) {
                    //me.listarPeriodos();
                    console.log(response.data[0]["error"]);
                    if (response.data[0]["error"]) {
                        me.snackbar = true;
                        me.text = response.data[0]["messagge"];
                    } else {
                        //me.listarPeriodos();
                        me.listar();
                        me.dialog2 = false;
                    }
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },

        GenerarPorSensor(item) {
            let me = this;
            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };

            axios
                .get(
                    "api/AccountsReceivables/InsertAccountReceivableSensor/" + me.edificio.id + "/" + item.id,

                    configuracion
                )
                .then(function (response) {

                    console.log(response.data[0]["error"]);
                    if (response.data[0]["error"]) {
                        me.snackbar = true;
                        me.text = response.data[0]["messagge"];
                    } else {

                        me.dialog3 = false;
                        me.listar();
                        //me.dialogSensorDetails = false;
                    }
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });
        },
        GenerarPago() {
            let me = this;

            let header = { Authorization: "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };

            axios
                .post(
                    "api/Payments/InsertPayment",
                    {
                        account_receivable_uq: me.id_pago,
                        PaymentDate: me.pickerPayment,
                        Amount: me.amountPayment,
                        PaymentMethod: me.methodPayment
                    },
                    configuracion
                )
                .then(function (response) {
                    //me.listarPeriodos();
                    console.log(response.data[0]["error"]);
                    if (response.data[0]["error"]) {
                        me.snackbar = true;
                        me.text = response.data[0]["messagge"];
                    } else {
                        //me.listarPeriodos();
                        me.verDetalles();
                        me.dialog1 = false;

                    }
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        this.$store.dispatch("salir");
                    }
                });

        },
        openDialog(dialog) {
            this[dialog] = true;
        }
    },
};
</script>